import React from 'react';
import NoResult from './questionChartsNoResult';
import { DonutChart } from '@citrus/chart';
import {
  Table,
  Tbody,
  Td,
  Tr,
  Th,
  Thead,
} from '@citrus/data-table';

const PieChart = ({ questionData, number, isSummary }) => {
  const responses = questionData.options;
  const participantResponses = questionData.participantResponses;
  const type = questionData.type;
  if(responses === null || responses.length === 0 || typeof(responses) !== typeof([]) ) {
    return (<NoResult number={number}/>);
  }

  const stats = [];
  if(type != "rating" && type != "starrating")
    responses.sort((a, b) => Number(b.count) - Number(a.count));
  responses.forEach(response => {
    const name = response.text + ": " + response.count;
    stats.push({name: name, value: response.count})
  });

  const config = {
    series: [{
      size: '75%',
      innerSize: '50%',
      showInLegend: true,
        tooltip: {
          pointFormat: ''
      },
      dataLabels: {
        enabled: true,
        format: '<b>{point.percentage:.1f} %'

      },
      data: stats.map(x => ({ name: x.name, y: x.value })),
   }],
  };

  return (
    <React.Fragment>
      <DonutChart config={config} data={stats} automationId={"question-" + number + "-donut-chart"}/>

      {!isSummary && <Table.Core
        automationId={"question-" + number + "-donut-graph"}
        itemCount={participantResponses.length}
        onChangePage={() => {}}
        page={1}
        pageSize={Number.MAX_SAFE_INTEGER}
        css={"div > div > div > span { display: none }"}
        renderZeroState={() => <ZeroState type="insufficientdata" />}>
          <Thead>
            <Th column="Participant">Participant</Th>
            <Th column="Response">Response</Th>
          </Thead>
          <Tbody>
            {participantResponses.map((participant, index) => (
              <Tr key={`participant-response-${index}`}>
                <Td>{participant.employeeName}</Td>
                <Td>{participant.response}</Td>
              </Tr>))
            }
          </Tbody>
      </Table.Core>}
    </React.Fragment>
  );
}

export default PieChart;